/**
 * Created by forbiz on 2019-02-11.
 */

import Swiper from 'swiper/dist/js/swiper'

const market = () => {

    const banner_slider = () => {
        hdFn.hdSlide('.market .slider', {
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,						// 5초에 한 번
            cssEase: 'linear',
            dots:true,
            appendDots: $(".slick-controller"),
            fade: true,
            infinite: true,
            speed: 500,								// 루프 실행 속도
        });

        if ( $('.slider__list').length <= 1 ) {
            $('.slick-controller').hide();
        }
    };

    const oveview_slider = () => {
        const navLength = $('.market__sect.oveview .slider-nav .swiper-slide').length;
        const forLength = $('.market__sect.oveview .slider-for .swiper-slide').length;

        if (forLength > 1) {
            $('.market__sect.oveview .slider-for').append('<div class="swiper-button-next"></div>\n<div class="swiper-button-prev"></div>');

            var oveviewFor = new Swiper('.market__sect.oveview .slider-for', {
                slidesPerView: 1,
                autoplay: true,
                loop: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }); 

            oveviewFor.on('slideChange', function(){
                var oveviewForIdx = oveviewFor.activeIndex - 1;
                if( oveviewForIdx < 0 ) {
                    oveviewForIdx = navLength - 1;
                } else if( oveviewForIdx == navLength ){
                    oveviewForIdx = 0;
                }
                $('.market__sect.oveview .slider-nav .swiper-slide').removeClass('on').eq(oveviewForIdx).addClass('on');

                if (navLength > 5) {
                    oveviewNav.slideTo(oveviewForIdx, 300);
                }
                oveviewFor.autoplay.start();
            });

            $('.market__sect.oveview').hover(function() {
                 oveviewFor.autoplay.stop();
            }, function(){
                 oveviewFor.autoplay.start();
            });
        }
        
        if (navLength > 5) {
            $('.market__sect.oveview .slider-nav').prepend('<div class="swiper-pagination"></div>');
            $('.market__sect.oveview .slider-nav').append('<div class="swiper-scrollbar"></div>');
            
            var oveviewNav = new Swiper('.market__sect.oveview .slider-nav', {
                direction: 'vertical',
                spaceBetween: 0,
                slidesPerView: 5,
                slidesPerGroup: 5,
                mousewheel: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }
            });

            $('.market__sect.oveview .slider-nav .swiper-pagination-bullet').on('click', function(e){
                const index = $(this).index();
                oveviewFor.slideTo(5 * index + 1, 0);
            });
        }

        $('.market__sect.oveview .slider-nav .swiper-slide').on('click', function(e){
            $(this).addClass('on').siblings().removeClass('on');
            const tabIdx = $(this).index();
            oveviewFor.slideTo(tabIdx+1, 0);
            e.preventDefault();
        });       
    }

    const market_init = () => {
        banner_slider();
    };

    market_init();

    window.oveview_slider = oveview_slider;
};

export default market;